import React, { Component } from "react"
import { Icon, Affix, Menu, DatePicker, Row, Button, Modal, Spin, message } from "antd"
import { observer, inject } from "mobx-react"
import moment from "moment"
import 'moment/locale/zh-cn'
moment.locale('zh-cn')

const { MonthPicker } = DatePicker
const monthFormat = 'YYYY-MM'

@inject("auth") @observer
class DataHeader extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
      exportModalShowed: false
    }
  }

  componentDidMount() {
    const { updateQueryMap } = this.props.store
    const currentMonth = moment(new Date()).format('YYYY-MM')
    updateQueryMap({ date: currentMonth + '-01' })
  }

  onMonthChange = (date, dateString) => {
    const { filterTimingTaskData } = this.props.store
    filterTimingTaskData({ date: dateString ? dateString + '-01' : '' })
  }

  onDayChange = (e) => {
    const {
      filterTimingTaskData
    } = this.props.store

    this.setState({
      dayKey: e.key,
    })

    filterTimingTaskData({ field: e.key === '-1' ? 0 : e.key })
  }

  exportDataStep1 = () => {
    const { exportDataStep1 } = this.props.store

    this.setState({
      exportModalShowed: true
    })

    exportDataStep1()
      .then(
        res => {
          const exportDataUrl = res.url
          this.setState({
            exportModalShowed: false,
          })
          if (document.getElementById("export-a-tag")) document.getElementById("export-a-tag").outerHTML = ""
          let a = document.createElement("iframe")
          a.setAttribute("src", exportDataUrl)
          a.setAttribute("id", "export-a-tag")
          a.setAttribute("style", "display:none;")
          if (!document.getElementById("export-a-tag")) document.body.appendChild(a)
        },
        err => {
          message.error("导出失败，请您重试！")
          this.setState({
            exportModalShowed: false,
          })
        }
      )
  }

  disabledDate = (current) => {
    return current && (current.valueOf() > new Date() || current.valueOf() < new Date('2019-01'))
  }

  renderDayMenu = () => {
    return (
      <div className="search-month-bar">
        <Row type="flex" justify="space-between" align="middle" className="content">
          <Row type="flex" align="middle">
            <Menu className="menu-day" onClick={e => this.onDayChange(e)}
              selectedKeys={[this.state.dayKey]}
              mode="horizontal"
              key="menu_date_0">
              <Menu.Item key="-1">
                <Icon type="calendar" />全部
              </Menu.Item>
              <Menu.Item key="1">一个月</Menu.Item>
              <Menu.Item key="2">三个月</Menu.Item>
              <Menu.Item key="3">半年</Menu.Item>
            </Menu>
            <MonthPicker
              defaultValue={moment(new Date(), monthFormat)}
              style={{ marginLeft: 20 }}
              onChange={this.onMonthChange}
              placeholder="请选择月份"
              disabledDate={this.disabledDate}
            />
          </Row>
          <Row type="flex" align="middle">
            <Button
              type="primary"
              size="default"
              className="export-btn"
              onClick={this.exportDataStep1}
            >
              <Icon type="download" />导出
            </Button>
          </Row>
        </Row>
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.state.exportModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">正在导出中，请稍等。。。</div>
        </Modal>
      </div>
    )
  }

  render() {
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          {this.renderDayMenu()}
        </div>
      </Affix>
    )
  }

}

export default DataHeader


// WEBPACK FOOTER //
// ./src/app/pages/pgs/data_statistics/timingTask/container/DataHeader.js